import { initializeSelectionsMachine } from '@databases/selections';
import { container } from '@databases/service-container';

import { getExperimentValue } from '@canvas/client-feature-flags';

/**
 * Initializes the selections machine behind a feature gate
 * with a listener on databaseContentIdChanged to destroy
 * and rebuild it, so no highlights or state exists between
 * changing the content id.
 */
export function initializeRecyclableSelectionsMachine() {
  const experimentIsEnabled = getExperimentValue(
    'databasesSelectionsPerformance',
    'isEnabled',
    {
      fireExperimentExposure: false,
    }
  );

  if (!experimentIsEnabled) {
    return;
  }

  let destroy = initializeSelectionsMachine();
  const eventBus = container.resolve('EventBus');

  eventBus.on('databaseContentIdChanged', () => {
    destroy();

    destroy = initializeSelectionsMachine();
  });
}
